import {
  RelayNetworkLayer,
  urlMiddleware,
  retryMiddleware,
  authMiddleware,
  loggerMiddleware,
  errorMiddleware,
  cacheMiddleware,
} from "react-relay-network-modern";
import { Environment, RecordSource, Store } from "relay-runtime";

import { getAccessToken } from "pianofunclub-crm/relay/getAccessToken";

// would ideally hide these in environment variables in .env (locally), expo (app) and Vercel (CRM)
// but .env isn't working with Yarn Workspace and Vercel Env Vars don't seem to be exposed to the code.
const PROD_FETCH_URL = "https://sb6qb56vha.execute-api.eu-west-1.amazonaws.com/prod/graphql";
const STAGING_FETCH_URL = "https://y3knf9x87b.execute-api.eu-west-1.amazonaws.com/staging/graphql";

// cannot run on localhost (use actual local ip address if running locally)
let FETCH_URL: string;
// set the fetch url based on the release channel
switch (process.env.REACT_APP_ENV) {
  case "prod":
    FETCH_URL = process.env.PROD_FETCH_URL ?? PROD_FETCH_URL ?? "";
    break;
  case "staging":
    FETCH_URL = process.env.STAGING_FETCH_URL ?? STAGING_FETCH_URL ?? "";
    break;
  default:
    FETCH_URL = `http://${process.env.LOCAL_IP}:8000/graphql`;
}

// use to create a fresh relay environment on first load or logout
export const createRelayEnvironment = ({
  clientSideLogout,
}: {
  clientSideLogout: () => void;
}): Environment => {
  const network = new RelayNetworkLayer(
    [
      urlMiddleware({
        url: () => Promise.resolve(FETCH_URL),
      }),
      retryMiddleware({
        fetchTimeout: 20 * 1000, // 20 seconds
        retryDelays: (attempt) => Math.pow(2, attempt + 4) * 100, // exp back-off
      }),
      authMiddleware({
        allowEmptyToken: true,
        prefix: "JWT ",
        token: () => getAccessToken({ clientSideLogout, fetchUrl: FETCH_URL }),
      }),
      cacheMiddleware({
        size: 100,
        ttl: 1000 * 60 * 45, // 45 mins
      }),
      loggerMiddleware(),
      errorMiddleware(),
    ],
    { noThrow: true }
  );

  const store = new Store(new RecordSource());

  return new Environment({
    network,
    store,
  });
};
